import { Form } from "@redriver/cinnamon-mui";
import { contractStatusLookup } from "modules/lookups";

const ContractStatusDropdown = (props) => (
  <Form.Dropdown {...props} lookup={contractStatusLookup} />
);

export default ContractStatusDropdown;
